/**
 * GraphQL Query
 * 権限ロール画面
 */

/**
 * 権限ロール一覧
 */
export const GRAPH_QL_QUERY_PERMISSION_ROLE_LIST =
`
query {
  permissionRoles ( ? ) {
    uuid
    name
  }
}
`

/**
 * 権限ロール詳細
 * 10階層まで取得する.
 */
export const GRAPH_QL_QUERY_PERMISSION_ROLE_DETAIL =
`
query {
  permissionRoles {
    uuid
    name
    permissions {
      config {
        key
        name
        editType
        parent {
          key
        }
        children {
          key
          name
          editType
          parent {
            key
          }
          children {
            key
            name
            editType
            parent {
              key
            }
            children {
              key
              name
              editType
              parent {
                key
              }
              children {
                key
                name
                editType
                parent {
                  key
                }
                children {
                  key
                  name
                  editType
                  parent {
                    key
                  }
                  children {
                    key
                    name
                    editType
                    parent {
                      key
                    }
                    children {
                      key
                      name
                      editType
                      parent {
                        key
                      }
                      children {
                        key
                        name
                        editType
                        parent {
                          key
                        }
                        children {
                          key
                          name
                          editType
                          parent {
                            key
                          }
                          displayOrder
                        }
                        displayOrder
                      }
                      displayOrder
                    }
                    displayOrder
                  }
                  displayOrder
                }
                displayOrder
              }
              displayOrder
            }
            displayOrder
          }
          displayOrder
        }
        displayOrder
      }
      value
    }
    updatedAt
  }
}
`

/**
 * 権限ロール項目設定情報
 * TODO このgraphqは必要？
 */
export const GRAPH_QL_QUERY_PERMISSION_ROLE_CONFIGS =
`
query {
  permissionConfigs {
    key
    name
    editType
    parent {
      key
    }
    children {
      key
      name
      editType
      parent {
        key
      }
      children {
        key
        name
        editType
        parent {
          key
        }
        children {
          key
          name
          editType
          parent {
            key
          }
          children {
            key
            name
            editType
            parent {
              key
            }
            children {
              key
              name
              editType
              parent {
                key
              }
              children {
                key
                name
                editType
                parent {
                  key
                }
                children {
                  key
                  name
                  editType
                  parent {
                    key
                  }
                  children {
                    key
                    name
                    editType
                    parent {
                      key
                    }
                    children {
                      key
                      name
                      editType
                      parent {
                        key
                      }
                      displayOrder
                    }
                    displayOrder
                  }
                  displayOrder
                }
                displayOrder
              }
              displayOrder
            }
            displayOrder
          }
          displayOrder
        }
        displayOrder
      }
      displayOrder
    }
    displayOrder
  }
}
`



// WEBPACK FOOTER //
// ./src/queries/permissionRole.js